<template>
  <div class="tltp-user">
    <div class="tltp-user__hdr">
      <AvatarImage :src="props.avatar" :size="38"/>
      <div class="tltp-user__hdr-txt-box">
        <span class="tltp-user__hdr-name">{{ props.name }}</span>
        <span class="tltp-user__hdr-nickname">{{ formatUsername(props.username) }}</span>
      </div>
    </div>
    <p class="tltp-user__description" v-if="props.description">
      {{ props.description }}
    </p>
    <div class="tltp-user__ftr" v-if="props.followers || props.xScore || props.twitterScore">
      <p class="tltp-user__ftr-item">
        <span class="tltp-user__ftr-value">{{ formatFollowers(props.followers) }}</span> Подписчиков
      </p>
      <p class="tltp-user__ftr-item" v-if="props.xScore">
        <span class="tltp-user__ftr-value">{{ props.twitterScore }}</span> X Score
      </p>
    </div>
  </div>
</template>

<script setup>
  import { Props } from './props';
  import { formatFollowers } from '@shared/utils/formated/formatFollowers';
  //----------------------------------
  import AvatarImage from '@shared/UI/Images/AvatarImage/AvatarImage.vue';
  //----------------------------------
  const props = defineProps(Props());
  //----------------------------------
  //Функция для форматирования username
  const formatUsername = (username) => {
    if (!username) return '';
    return username.startsWith('@') ? username : `@${username}`;
  };
  //----------------------------------
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>